"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _constants = require("composer-lib/lib/constants");

var _classnames = _interopRequireDefault(require("classnames"));

var _ComposerSettings = _interopRequireDefault(require("composer-lib/data/model/ComposerSettings"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _utils = require("composer-lib/lib/utils");

var _reactKeybindings = require("react-keybindings");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _UsageTracking = require("composer-lib/lib/UsageTracking");

var _UIExpandingTextArea = _interopRequireDefault(require("UIComponents/input/UIExpandingTextArea"));

var _UIFormLabel = _interopRequireDefault(require("UIComponents/form/UIFormLabel"));

var _MaxLengthWarning = _interopRequireDefault(require("composer-lib/components/composer/MaxLengthWarning"));

var TitleEditor = (0, _createReactClass.default)({
  displayName: "TitleEditor",
  mixins: [_reactAddonsPureRenderMixin.default],
  propTypes: {
    autoFocus: _propTypes.default.bool.isRequired,
    className: _propTypes.default.string,
    composerSettings: _propTypes.default.instanceOf(_ComposerSettings.default).isRequired,
    compositionTypeString: _propTypes.default.string,
    highlighted: _propTypes.default.bool,
    maxLength: _propTypes.default.number,
    maxLengthWarningThreshold: _propTypes.default.number,
    readOnly: _propTypes.default.bool,
    registerListener: _propTypes.default.func.isRequired,
    required: _propTypes.default.bool.isRequired,
    saveChangedComposition: _propTypes.default.func.isRequired,
    setBodyEditorActive: _propTypes.default.func.isRequired,
    showLabel: _propTypes.default.bool.isRequired,
    showMaxLengthWarning: _propTypes.default.bool,
    tabIndex: _propTypes.default.string,
    title: _propTypes.default.string,
    toggleShowAddConversationButton: _propTypes.default.func.isRequired,
    updateTitleToSave: _propTypes.default.func.isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      maxLength: _constants.MAX_TITLE_LENGTH
    };
  },
  getInitialState: function getInitialState() {
    return {
      userHasTyped: false
    };
  },
  componentDidMount: function componentDidMount() {
    this.props.registerListener('cmd+s', this.handleSave);
    this.props.registerListener('enter', this.handleReturn);
  },
  handleKeyUp: function handleKeyUp(e) {
    if (document.activeElement === e.target) {
      // Allow selection state to change in editor due to mouseup before inspecting it
      setTimeout(this.toggleShowAddConversationButton, 0);
    }

    return;
  },
  handleReturn: function handleReturn(e) {
    e.preventDefault();
    e.target.blur();
  },
  toggleShowAddConversationButton: function toggleShowAddConversationButton() {
    this.props.toggleShowAddConversationButton(this._editorRef.current);
  },
  handleSave: function handleSave(e) {
    e.preventDefault();
    (0, _UsageTracking.trackEvent)({
      action: 'save-via-keyboard-shortcut',
      name: _constants.AmplitudeEvents.COMPOSITION_INTERACTION.INTERACTION
    });
    this.props.saveChangedComposition();
  },
  onChange: function onChange(_ref) {
    var _this = this;

    var value = _ref.target.value;
    this.setState({
      userHasTyped: value.length > 0
    }, function () {
      _this.props.updateTitleToSave(value);
    });
  },
  onFocus: function onFocus() {
    this.props.setBodyEditorActive(false);
  },
  getPlaceholder: function getPlaceholder() {
    var compositionTypeString = this.props.compositionTypeString;
    return (0, _utils.getTitlePlaceholder)(compositionTypeString);
  },
  getTempTitle: function getTempTitle() {
    var compositionTypeString = this.props.compositionTypeString;
    return (0, _utils.getTemporaryTitle)(compositionTypeString);
  },
  getTitle: function getTitle() {
    var title = this.props.title;

    if (title === this.getPlaceholder() || title === this.getTempTitle()) {
      return '';
    }

    return title;
  },
  renderLabel: function renderLabel(required, showLabel, title, typeString) {
    var userHasTyped = this.state.userHasTyped;

    if (!showLabel) {
      return null;
    }

    return _react.default.createElement(_UIFormLabel.default, {
      className: (0, _classnames.default)({
        'visibility-hidden': userHasTyped || title.length > 0
      }),
      required: required
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "composer-lib.composer.titleLabel." + typeString
    }));
  },
  renderWarning: function renderWarning(value, maxLength, maxLengthWarningThreshold) {
    return _react.default.createElement(_MaxLengthWarning.default, {
      value: value,
      maxLength: maxLength,
      maxLengthWarningThreshold: maxLengthWarningThreshold
    });
  },
  render: function render() {
    var _this$props = this.props,
        autoFocus = _this$props.autoFocus,
        className = _this$props.className,
        compositionTypeString = _this$props.compositionTypeString,
        composerSettings = _this$props.composerSettings,
        highlighted = _this$props.highlighted,
        maxLength = _this$props.maxLength,
        maxLengthWarningThreshold = _this$props.maxLengthWarningThreshold,
        readOnly = _this$props.readOnly,
        required = _this$props.required,
        showLabel = _this$props.showLabel,
        showMaxLengthWarning = _this$props.showMaxLengthWarning,
        tabIndex = _this$props.tabIndex,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["autoFocus", "className", "compositionTypeString", "composerSettings", "highlighted", "maxLength", "maxLengthWarningThreshold", "readOnly", "required", "showLabel", "showMaxLengthWarning", "tabIndex"]);
    this._editorRef = this._editorRef || _react.default.createRef();
    var containerClassnames = (0, _classnames.default)('composition-title-container', {
      'composer-width m-x-auto': composerSettings.get('fullScreen')
    });
    var editorClassnames = (0, _classnames.default)('no-user-select composition-title', (0, _defineProperty2.default)({
      'highlighted-by-conversation': highlighted
    }, className, className));
    var title = this.getTitle();
    var allowedTextAreaProps = Object.keys(_UIExpandingTextArea.default.propTypes);
    var extraProps = Object.assign({}, allowedTextAreaProps.reduce(function (prev, prop) {
      return rest.hasOwnProperty(prop) ? Object.assign({}, prev, (0, _defineProperty2.default)({}, prop, rest[prop])) : prev;
    }, {}), {}, Object.keys(rest).filter(function (restKey) {
      return /^data-/.test(restKey);
    }).reduce(function (prev, restKey) {
      return Object.assign({}, prev, (0, _defineProperty2.default)({}, restKey, rest[restKey]));
    }, {}));
    return _react.default.createElement("div", {
      className: containerClassnames
    }, this.renderLabel(required, showLabel, title, compositionTypeString), _react.default.createElement(_UIExpandingTextArea.default, Object.assign({}, extraProps, {
      autoFocus: autoFocus,
      className: editorClassnames,
      "data-gramm": false,
      id: _constants.TITLE_ID,
      inputRef: this._editorRef,
      maxLength: maxLength,
      onBlur: this.handleSave,
      onChange: this.onChange,
      onFocus: this.onFocus,
      onKeyUp: this.handleKeyUp,
      onMouseUp: this.toggleShowAddConversationButton,
      placeholder: this.getPlaceholder(),
      readOnly: readOnly,
      shrink: true,
      styled: false,
      tabIndex: tabIndex,
      value: title
    })), showMaxLengthWarning && this.renderWarning(title, maxLength, maxLengthWarningThreshold));
  }
});

var _default = (0, _reactKeybindings.KeyboundComponent)(TitleEditor);

exports.default = _default;
module.exports = exports.default;